import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { FlexGap, GearIcon, IconButton, QuestionMarkIcon, tokens } from '@treams/treams-ui';

import { Profile, Search } from './TopBar';

export function MobileNavActions() {
	return (
		<Box display={['block', 'block', 'none']} mb={`${tokens.gap.list}px`}>
			<Search />
		</Box>
	);
}

export function MobileNavAccount() {
	const { t } = useTranslation();
	const query = graphql.useViewerQuery();

	return (
		<Box display={['block', 'block', 'none']} flexShrink={0} pt={`${tokens.gap.list}px`}>
			<FlexGap flexDirection="column" gap={tokens.gap.list} width="100%">
				<FlexGap gap={tokens.gap.element}>
					<a href="https://guides.ontreams.com/nl/" target="_blank" rel="noreferrer">
						<IconButton type="secondary" icon={<QuestionMarkIcon />} />
					</a>
					<IconButton
						type="secondary"
						icon={<GearIcon />}
						link="/personal-settings"
						aria-label={t('menu.context.personalSettings')}
					/>
				</FlexGap>
				{query.data ? (
					<Profile fullWidth user={query.data.viewer as graphql.User} />
				) : (
					<Profile.Skeleton width="100%" />
				)}
			</FlexGap>
		</Box>
	);
}
